// extracted by mini-css-extract-plugin
export default {"document-detail-breadcrumbs__folder-breadcrumb":"DocumentDetailBreadcrumbs_document-detail-breadcrumbs__folder-breadcrumb__vjvmf"};